import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import RichTextImpl from "~/components/RichText";
import CTAButton from "~/components/CTAButton";
import Seal from "~/components/Seal";
import Wrapper from "~/components/SliceWrapper";

/**
 * Props for `RichText`.
 */
export type RichTextProps = SliceComponentProps<Content.RichTextSlice>;

/**
 * Component for "RichText" Slices.
 *
 * Legacy API data may include fields (seal, text_center, cta_text, cta_link)
 * not present in the migrated SharedSlice model.
 */
const RichText: FC<RichTextProps> = ({ slice }) => {
  const primary = slice.primary as Record<string, any>;

  return (
    // @ts-expect-error — SliceWrapper is an untyped JS component
    <Wrapper
      cssClass="rte slice-padding overflow-hidden relative"
      data-analytics-component="rich-text"
      slice={slice}
      verticalPadding={false}
    >
      {primary.seal && <Seal theme={primary.theme} />}
      <div
        className={`max-875 mx-auto ${
          primary.text_center ? "text-center" : ""
        }`}
      >
        <RichTextImpl field={slice.primary.text} />
        {primary.cta_text && primary.cta_link ? (
          <div
            className={`button-block ${
              primary.seal || primary.text_center ? "text-center" : ""
            }`}
          >
            {/* @ts-expect-error — CTAButton is an untyped JS component */}
                        <CTAButton field={primary} />
          </div>
        ) : null}
      </div>
    </Wrapper>
  );
};

export default RichText;
